const doc = [({"ja":({"adminConstantHotelFilterType":({"meal":"食事", "planOption":"プランのこだわり", "roomAmenity":"部屋アメニティ", "roomProperty":"部屋のこだわり"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;